$(function () {
    $('[data-popup]').on('click', function (event) {
        event.preventDefault();

        const id = $(this).data('popup');
        window.showPopup(id);
    });

    $('.popup__toggle').on('click', function () {
        const id = $(this).parent().get(0).id;
        window.closePopup(id);
    });

    window.showPopup = function (id) {
        const popup = $('#popup--' + id);

        if (!popup.length) {
            return;
        }

        window.saveScrollPosition();

        popup.fadeIn(function () {
            window.disable_scroll();
        });
    };

    window.closePopup = function (id) {
        const popup = $('#' + id);

        if (!popup.length) {
            return;
        }

        window.enable_scroll();
        popup.fadeOut();
    };

    $(document).on('keyup', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            const popup = $('.popup:visible');

            if (!popup.length) {
                return;
            }

            const id = popup.get(0).id;

            window.closePopup(id);
        }
    });
});
